import { render, staticRenderFns } from "./NewModelModal.vue?vue&type=template&id=6a1f049b&"
import script from "./NewModelModal.vue?vue&type=script&lang=js&"
export * from "./NewModelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports